import { setToken, removeToken, getToken } from '@/utils/auth'

const state = {
  token:getToken() || '', //共享的 token
}
const mutations = { 
  // 对token进行赋值
  setToken(state,token) {
    state.token = token
    // 将token 持久化存储到本地
    setToken(token)
  },
  // 移除token
  removeToken(state) {
    state.token = ''
    removeToken()
  }
}
const actions = {
  // 新增：重置 user 模块的 action
  resetUserState({ commit }) {
    // 使用现有的 removeToken mutation 重置状态
    commit('removeToken')
    
    // 如果需要重置其他状态，可以添加更多 commit
    // commit('resetOtherState')
  }
}


export default {
  namespaced:true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js